/* PADEN STORE V48 — micro-interactions, lookbook, packs et animations. */
(() => {
  'use strict';
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Accessible mobile navigation, with all links kept visible to keyboard users.
  const menuButton = document.querySelector('.paden-menu-toggle');
  const navigation = document.getElementById('paden-navigation');
  if (menuButton && navigation) {
    const setMenu = opened => {
      menuButton.setAttribute('aria-expanded', String(opened));
      menuButton.setAttribute('aria-label', opened ? 'Fermer le menu' : 'Ouvrir le menu');
      navigation.classList.toggle('paden-menu-open', opened);
    };
    menuButton.addEventListener('click', () => setMenu(menuButton.getAttribute('aria-expanded') !== 'true'));
    navigation.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') setMenu(false); });
    document.addEventListener('click', e => { if (!navigation.contains(e.target) && !menuButton.contains(e.target)) setMenu(false); });
  }

  // Lookbook is intentionally non-clickable: pure inspiration, swipe + controls.
  const lookbook = document.getElementById('paden-lookbook-track');
  if (lookbook) {
    const items = [...lookbook.children];
    let paused = false;
    let timer;
    const advance = direction => {
      if (!items.length) return;
      const stride = items[0].getBoundingClientRect().width + 16;
      if (direction > 0 && lookbook.scrollLeft + lookbook.clientWidth >= lookbook.scrollWidth - 30) {
        lookbook.scrollTo({left: 0, behavior: reduceMotion ? 'auto' : 'smooth'});
      } else if (direction < 0 && lookbook.scrollLeft < 20) {
        lookbook.scrollTo({left: lookbook.scrollWidth, behavior: reduceMotion ? 'auto' : 'smooth'});
      } else {
        lookbook.scrollBy({left: direction * stride, behavior: reduceMotion ? 'auto' : 'smooth'});
      }
    };
    const previous = document.querySelector('[data-lookbook-prev]');
    const next = document.querySelector('[data-lookbook-next]');
    previous?.addEventListener('click', () => advance(-1));
    next?.addEventListener('click', () => advance(1));
    const stage = lookbook.closest('.paden-new-hero');
    ['pointerenter','focusin','touchstart'].forEach(event => stage?.addEventListener(event, () => { paused = true; }, {passive: true}));
    ['pointerleave','focusout','touchend'].forEach(event => stage?.addEventListener(event, () => { paused = false; }, {passive: true}));
    if (!reduceMotion) {
      timer = window.setInterval(() => {
        if (!paused && !document.hidden) advance(1);
      }, 3900);
      window.addEventListener('pagehide', () => clearInterval(timer), {once:true});
    }
  }

  // Reveal only after observer has been registered to avoid hiding any content if JS fails.
  if (!reduceMotion && 'IntersectionObserver' in window) {
    const reveals = [...document.querySelectorAll('.paden-reveal,.future-card,.paden-ls-card,.paden-pack')];
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('paden-visible'); observer.unobserve(entry.target); }
    }), {threshold: .08, rootMargin: '0px 0px 40px 0px'});
    reveals.forEach(el => { el.classList.add('paden-motion-ready'); observer.observe(el); });
  }

  // Packs are two real Shopify variants, added in a single AJAX request.
  // Discounts, if any, must be created in Shopify: the theme cannot change checkout prices.
  const euro = cents => new Intl.NumberFormat('fr-FR', {style:'currency', currency:'EUR'}).format(cents / 100);
  document.querySelectorAll('[data-paden-pack]').forEach(card => {
    const picks = [...card.querySelectorAll('[data-pack-variant]')];
    const button = card.querySelector('[data-pack-add]');
    const price = card.querySelector('.paden-pack-live-price');
    const message = card.querySelector('[data-pack-message]');
    if (!button || picks.length !== 2) return;
    const refresh = () => {
      const chosen = picks.map(select => select.selectedOptions[0]);
      const complete = chosen.every(opt => opt && opt.value && !opt.disabled);
      button.disabled = !complete;
      if (price) price.textContent = complete
        ? `TOTAL DES DEUX PIÈCES : ${euro(chosen.reduce((sum, opt) => sum + Number(opt.dataset.price || 0), 0))}`
        : 'Choisis une taille disponible pour chaque coloris.';
    };
    picks.forEach(select => select.addEventListener('change', () => { if (message) message.textContent = ''; refresh(); }));
    refresh();
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled = true;
      if (message) message.textContent = 'Ajout des deux pièces…';
      try {
        const ids = picks.map(select => Number(select.value));
        if (ids.some(id => !Number.isSafeInteger(id) || id <= 0)) throw Error('Sélectionne deux tailles valides.');
        const res = await fetch((window.Shopify && window.Shopify.routes?.root ? window.Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type':'application/json', 'Accept':'application/json'},
          body: JSON.stringify({items: ids.map(id => ({id, quantity:1, properties:{'Duo Paden Store':card.dataset.padenPack + ' · Noir + Gris'}}))})
        });
        if (!res.ok) {
          const error = await res.json().catch(() => ({}));
          throw Error(error.description || error.message || 'Le duo ne peut pas être ajouté pour le moment.');
        }
        if (message) message.textContent = 'Les deux pièces ont été ajoutées au panier.';
        if (window.PadenCart?.open) window.PadenCart.open();
        else window.location.href = '/cart';
      } catch (err) {
        if (message) message.textContent = err.message || 'Impossible d’ajouter le pack.';
      } finally { refresh(); }
    });
  });
})();
